













import { Component, Vue, Prop } from 'vue-property-decorator'

import ContentLoader from '@/components/contentLoaders/ContentLoader'
import ContentLoaderAdaptivePricingCurrency from '@/components/contentLoaders/ContentLoaderAdaptivePricingCurrency.vue'
import ContentLoaderBookingMessage from '@/components/contentLoaders/ContentLoaderBookingMessage.vue'
import ContentLoaderBookingMessageMobile from '@/components/contentLoaders/ContentLoaderBookingMessageMobile.vue'
import ContentLoaderBookingPassenger from '@/components/contentLoaders/ContentLoaderBookingPassenger.vue'
import ContentLoaderBookingPassengerMobile from '@/components/contentLoaders/ContentLoaderBookingPassengerMobile.vue'
import ContentLoaderCreditNotes from '@/components/contentLoaders/ContentLoaderCreditNotes.vue'
import ContentLoaderLines from '@/components/contentLoaders/ContentLoaderLines.vue'
import ContentLoaderPayment from '@/components/contentLoaders/ContentLoaderPayment.vue'
import ContentLoaderPaymentMobile from '@/components/contentLoaders/ContentLoaderPaymentMobile.vue'
import ContentLoaderProfile from '@/components/contentLoaders/ContentLoaderProfile.vue'
import ContentLoaderReview from '@/components/contentLoaders/ContentLoaderReview.vue'

@Component({
  components: {
    ContentLoader,
    ContentLoaderAdaptivePricingCurrency,
    ContentLoaderLines,
    ContentLoaderPayment,
    ContentLoaderPaymentMobile,
    ContentLoaderBookingPassenger,
    ContentLoaderBookingPassengerMobile,
    ContentLoaderProfile,
    ContentLoaderBookingMessage,
    ContentLoaderBookingMessageMobile,
    ContentLoaderCreditNotes,
    ContentLoaderReview,
  },
})
export default class LoadingPlaceholder extends Vue {
  @Prop() contentLoaded!: boolean
  @Prop({ default: 'ContentLoader' }) placeholder!: string
  @Prop({
    default: () => {
      return {}
    },
  })
  loaderOptions!: any

  // Below is a trick for a slide-in animation. It's not currently required and has to be optional
  // In order for this to work:
  // 1. Uncomment everything below
  // 2. Add @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" to <transition>
  // 3. Add transition: .slide-enter-active, .slide-leave-active {transition:  max-height .5s }
  // 6. Bind :style to loader's wrapper with v-if="loading"
  // 5. Add "overflow-y: hidden" to .slot
  // 7. Make it optional and disabled by default

  // initialMaxHeight = 'none';

  // get loaderContainerStyle() {
  //   return {
  //     height: this.height,
  //   }
  // }

  // // Set the initial height before appearance
  // beforeEnter(el: HTMLElement) {
  //   this.initialMaxHeight = el.style.maxHeight || 'none';
  //   el.style.maxHeight = `${this.height}px`;
  // }

  // // Set the actual height
  // enter(el: HTMLElement) {
  //   const scrollHeight = el.scrollHeight;
  //   el.style.maxHeight = `${scrollHeight}px`;
  // }

  // // Reset max-height
  // afterEnter(el: HTMLElement) {
  //   el.style.maxHeight = this.initialMaxHeight;
  // }
}
